import { motion } from "framer-motion";
import { careerTabs, job } from "../../utilities/careersData";
import { useEffect, useState } from "react";
import GlobalBanner from "../../components/banner";
import EndingBanner from "../../components/endingBanner";
import DefaultPadding from "../../utilities/constants";
import CareerTabs from "../../components/careers/tabs";
import MapPin from "../../assets/careers/mapPin.svg";
import Clock from "../../assets/careers/clock.svg";
import Modal from "../../components/careers/modal";
import CareerBanner from "../../assets/banner/CarrersBanner.png";

const Careers = () => {
  useEffect(() => {
    window.scroll({
      top: 0,
      behavior: "instant",
    });
  }, []);

  const padding = new DefaultPadding();
  const defaultPaddingX = padding.getDefaultPaddingX();
  const defaultPaddingY = padding.getDefaultPaddingY();
  const [showModal, setShowModal] = useState(false);
  const [jobId, setJobId] = useState(null);

  return (
    <main className="relative">
      <Modal showModal={showModal} setShowModal={setShowModal} id={jobId} />
      <GlobalBanner bannerImg={CareerBanner}>
        Join <span className="text-visOrange">Vis Group</span>
      </GlobalBanner>
      <section className={`${defaultPaddingX} ${defaultPaddingY} space-y-10`}>
        <h1 className="text-center text-4xl text-visBlue">
          Job Openings at Vis Group
        </h1>
        <CareerTabs tabs={careerTabs}>
          {job.map((item, index) => {
            return (
              <div className="grid grid-cols-1 gap-7 md:grid-cols-2 xl:grid-cols-4">
                {item.jobs.map((job, idx) => {
                  return (
                    <motion.div
                      key={idx}
                      whileHover={{
                        scale: 1.05,
                        backgroundColor: "#1F3B7D",
                        color: "white",
                        transition: {
                          type: "spring",
                          stiffness: 150,
                          duration: 0.1,
                        },
                      }}
                      className="group col-span-1 px-5 py-5 shadow-shadow25 [&>h2]:text-visBlue"
                    >
                      <div className="flex h-full flex-col justify-between gap-5">
                        <div className="space-y-5">
                          <h2 className="text-24 text-visBlue group-hover:text-white">
                            {job.label}
                          </h2>
                          <hr />
                          <p>{job.discription}</p>
                          <div className="space-y-2">
                            <div className="tet flex gap-3 font-semibold text-visOrange">
                              <img src={MapPin} alt="" />
                              <span>{job.location}</span>
                            </div>
                            <div className="flex gap-3 font-semibold text-visOrange">
                              <img src={Clock} alt="" />
                              <span>{job.type}</span>
                            </div>
                          </div>
                        </div>
                        <button
                          onClick={() => {
                            setJobId((prev) => job.id);
                            setShowModal((prev) => true);
                          }}
                          className="w-fit bg-visOrange px-5 py-2 font-semibold text-white"
                        >
                          Apply now
                        </button>
                      </div>
                    </motion.div>
                  );
                })}
              </div>
            );
          })}
        </CareerTabs>
      </section>

      <EndingBanner buttonText="Contact Now" />
    </main>
  );
};

export default Careers;
